import { Component } from '@angular/core';
import { Platform, MenuController } from '@ionic/angular';
import { Router } from '@angular/router';
import { HelperProvider } from './services/helper/helper';
import { BasketakiRestProvider } from './services/basketaki-rest/basketaki-rest';
import { SharedDataProvider } from './services/shared-data/shared-data';
import { SettingsProvider } from './services/settings/settings';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages = [
    { title: 'NewGame', url: 'new-game', icon: 'add-circle-outline' },
  ];

  async newGame() {
    await this.settings.set('currentGame', null);
    this.router.navigate(['/new-game']);
  }
  constructor(
    public settings: SettingsProvider,
    private router: Router,
    public platform: Platform,
    public helper: HelperProvider,
    private storage: Storage,
    public rest: BasketakiRestProvider,
    public menuController: MenuController,
    public sharedData: SharedDataProvider
  ) {
    this.initializeApp();
  }

  async initializeApp() {
    await this.platform.ready();
    await this.helper.fillShared();
    await this.helper.openStartPage();
  }
  async ngOnInit() {
    await this.storage.create();
  }
  logout() {
    //console.log('logout');
    this.closeMenu();
    this.rest.logOut();
  }
  closeMenu() {
    this.menuController.close();
  }
}
